
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class GroupGeneric extends Vue {
  @Prop() data!: any;
}
